import Service from '../Service'
import {http} from '../config'

export default class OrcamentoService extends Service{

    constructor(){
        super('orcamento');
    }

    GerenciarItens(id, itens){
        return http.post(`${this._nomeControle}/${id}/GerenciarItens`, itens);
    }

    Relatorio(id){
        return http.get(`${this._nomeControle}/${id}/Relatorio`);
    }
    
}